import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Lock, Truck } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-20" data-testid="footer">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-[1280px] py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="flex items-start gap-3">
            <Shield className="h-5 w-5 text-primary mt-1" />
            <div>
              <h3 className="font-medium text-foreground mb-1">Escrow Protection</h3>
              <p className="text-sm text-muted-foreground">Secure transactions with buyer protection</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Lock className="h-5 w-5 text-primary mt-1" />
            <div>
              <h3 className="font-medium text-foreground mb-1">Verified Listings</h3>
              <p className="text-sm text-muted-foreground">Every watch authenticated by experts</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Truck className="h-5 w-5 text-primary mt-1" />
            <div>
              <h3 className="font-medium text-foreground mb-1">Insured Shipping</h3>
              <p className="text-sm text-muted-foreground">Worldwide delivery with full insurance</p>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-medium text-foreground mb-3">Marketplace</h4>
              <ul className="space-y-2">
                <li><Link to="/catalog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Browse Watches</Link></li>
                <li><Link to="/catalog?brand=" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Brands</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-foreground mb-3">Company</h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">About Us</Link></li>
                <li><Link to="/authentication" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Authentication</Link></li>
                <li><Link to="/trust-safety" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Trust & Safety</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-foreground mb-3">Support</h4>
              <ul className="space-y-2">
                <li><Link to="/help" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Help Center</Link></li>
                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact Us</Link></li>
                <li><Link to="/shipping-returns" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Shipping & Returns</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-foreground mb-3">Legal</h4>
              <ul className="space-y-2">
                <li><Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link></li>
                <li><Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
                <li><Link to="/cookies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Cookie Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-6 text-center">
          <p className="text-sm text-muted-foreground">&copy; {new Date().getFullYear()} V watch. Verified Timepieces. Curated Trust.</p>
        </div>
      </div>
    </footer>
  );
}
